// extracted by mini-css-extract-plugin
export default {"newsList":"index-module_newsList_NZUf-","news":"index-module_news_AG9vX","title":"index-module_title_-5wkv"};